// Escaping "<" prevents values such as "</script>" from breaking out of the script tag.
export const serializeJsonLd = (data) => JSON.stringify(data).replace(/</g, '\\u003c');
